
import { usePermissions } from '@/contexts/unified-permissions';

export const useAdminStatus = () => {
  const { isAdmin, permissionsStatus } = usePermissions();
  
  // For backward compatibility, return the same interface
  return { 
    isAdmin, 
    loading: permissionsStatus === 'loading' 
  };
};
